import { useContext } from 'react'

import { SignalingContext } from './context'

export function useSignaling() {
  const context = useContext(SignalingContext)

  if (!context) {
    throw new Error('useSignaling must be used within SignalingProvider')
  }

  return context
}
